<template>
  <div id="survey">
    <span class="mdi mdi-close icon-scale bigger close-button"
          @click="$emit('close')">
    </span>
    <div class="flex flex-column align-center survey-header">
      <p class="font-mitr">แบบประเมิณความพึงพอใจ</p>
      <p class="font-mitr">ในการรับบริการ</p>
    </div>
    <hr width="90%" style="height: 3px; background-color: #727F8A; margin: .5rem;">
    <div class="flex flex-column question">
      <div v-for="(survey,index) in surveyList" :key="index">
        <label class="q-label">
          {{ survey.no }}. {{ survey.question }}
        </label>
        <div class="flex justify-evenly" v-if="survey.answerType === 'rate'">
          <img class="star" v-for="(star, i) in survey.answer" :key="i+'s'"
               :src="require(`@/assets/img/${star}.svg`)"
               @click="select(index, i)"/>
        </div>
        <b-input v-else type="textarea" rows="2" v-model="survey.answer" placeholder="พิมพ์ข้อเสนอแนะที่นี่"></b-input>
      </div>
      <a class="button is-rounded send"
         @click.prevent="postSurvey">ส่งแบบสอบถาม</a>
    </div>
  </div>
</template>

<script>
import { getSurvey, submitSurvey } from '../services/api/surveyController'
import { mapState } from 'vuex'
import moment from 'moment'

const props = {
  activityId: {
    type: String,
    default: ''
  },
  serviceType: {
    type: String,
    default: 'examination'
  }
}

export default {
  name: 'surveyPopup',
  props,
  data () {
    return {
      satisfactionOne: new Array(5).fill('favoriteGray'),
      satisfactionTwo: new Array(5).fill('favoriteGray'),
      suggestion: '',
      surveyList: []
    }
  },
  computed: {
    ...mapState([
      'hn',
      'visitId'
    ])
  },
  async mounted () {
    try {
      this.surveyList = await getSurvey()
      for (let survey of this.surveyList) {
        if (survey.answerType === 'rate') survey.answer = new Array(5).fill('favoriteGray')
        else survey.answer = ''
      }
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    select (i, index) {
      this.surveyList[i].answer = new Array(index + 1).fill('favorite').concat(new Array(4 - index).fill('favoriteGray'))
      this.surveyList = Object.assign([], this.surveyList)
    },
    postSurvey () {
      let answerList = []
      for (let survey of this.surveyList) {
        let answer = survey.answer
        if (survey.answerType === 'rate') answer = this.getAnswerRate(survey.answer)
        let answerDict = {
          answer: answer,
          hn: this.hn,
          activityId: this.activityId,
          visitId: this.visitId,
          surveyId: survey._id,
          surveyDate: +moment(),
          serviceType: this.serviceType
        }
        answerList.push(answerDict)
        this.$emit('close')
      }
      submitSurvey({ surveys: answerList })
    },
    getAnswerRate (answer) {
      const satis = answer.lastIndexOf('favorite')
      if (satis !== -1) {
        return satis + 1
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#survey {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.3rem;
  padding: 1rem;
  margin: 1rem;

  .survey-header {
    color: #275583;
    font-weight: bold;
  }

  .question {
    width: 100%;

    .q-label {
      margin: .5rem 0;
    }

    .star {
      height: 3rem;
    }

    .send {
      width: 80%;
      background-color: #347187;
      color: #ffffff;
      margin-top: 1rem;
      margin-left: auto;
      margin-right: auto;
      font-weight: bold;
    }
  }
}
</style>
